import { updateSlideInDeck } from "../editor/deckEditor.js";
import { deriveSlideTextSubject } from "../outline/outlineSlide.js";
import { surfBedrockChat } from "./surfBedrockChat.js";
import { stylePalettePromptSegments, styleTreatmentForPrompt, } from "../style/stylePrompt.js";
const FROM_STYLE_SYSTEM = [
    "You rewrite presentation slide IMAGE prompts from a deck style treatment.",
    "Output ONLY the new English image prompt as plain text (no JSON, no markdown).",
    "The prompt must describe what to generate for the slide background or hero image.",
    "Respect the style treatment; incorporate slide content subject; keep look-only for widget-overlay mode when asked.",
    "Never invent facts or numbers not present in the slide content.",
].join("\n");
function slideContentSummary(slide) {
    const title = slide.layers.find((l) => l.type === "text" && l.textRole === "title")?.content?.trim();
    const bullets = slide.layers
        .filter((l) => l.type === "text" && l.textRole === "bullet")
        .map((l) => l.content.trim())
        .filter(Boolean);
    const body = slide.layers.find((l) => l.type === "text" && l.textRole === "body")?.content?.trim();
    return [
        title ? `Title: ${title}` : "",
        bullets.length ? `Bullets: ${bullets.join(" | ")}` : "",
        body ? `Body: ${body.slice(0, 200)}` : "",
        slide.outlineRole ? `Role: ${slide.outlineRole}` : "",
        slide.background.prompt ? `Current prompt: ${slide.background.prompt}` : "",
    ]
        .filter(Boolean)
        .join("\n");
}
function buildFromStyleUserPrompt(style, slide, slideIndex) {
    const subject = deriveSlideTextSubject(slide);
    return [
        `Slide ${slideIndex + 1}`,
        `Style treatment: ${styleTreatmentForPrompt(style)}`,
        ...stylePalettePromptSegments(style),
        `Realism: ${style.backgroundRealism}`,
        `Slide content:\n${slideContentSummary(slide)}`,
        `Authoritative subject line: ${subject}`,
        "Rewrite the image generation prompt for this slide so it matches the style treatment and slide content.",
        "If composition mode is composed-background, describe integrated layout/illustration with calm zone for text widgets; forbid readable text in the image.",
    ].join("\n\n");
}
export async function rewriteSlideImagePromptFromStyle(cfg, style, slide, slideIndex) {
    const raw = await surfBedrockChat(cfg, {
        feature: "surf.slide.prompt.fromStyle",
        systemText: FROM_STYLE_SYSTEM,
        userText: buildFromStyleUserPrompt(style, slide, slideIndex),
        maxTokens: 1024,
    });
    const prompt = raw.trim();
    if (!prompt)
        throw new Error("Riscrittura prompt slide vuota.");
    return prompt.slice(0, 2000);
}
export async function rewriteDeckSlidePromptsFromStyle(cfg, deck, slideIds) {
    const targets = slideIds?.length
        ? deck.slides.filter((s) => slideIds.includes(s.id))
        : deck.slides;
    let next = deck;
    for (const slide of targets) {
        const slideIndex = next.slides.findIndex((s) => s.id === slide.id);
        if (slideIndex < 0)
            continue;
        const prompt = await rewriteSlideImagePromptFromStyle(cfg, next.theme, slide, slideIndex);
        next = updateSlideInDeck(next, slide.id, (s) => ({
            ...s,
            background: { ...s.background, prompt },
        }));
    }
    return next;
}
export async function rewriteSingleSlidePromptFromStyle(cfg, deck, slideId) {
    return rewriteDeckSlidePromptsFromStyle(cfg, deck, [slideId]);
}
